// frontend/src/components/ListaAlunos/ModelEditarAluno.js
import React, { useState, useEffect } from "react";
import "./ModalEditarAluno.css";

const ModalEditarAluno = ({ aluno, onClose, onAtualizar }) => {
  const formatarDataParaInput = (dataIso) => {
    if (!dataIso) return "";
    const data = new Date(dataIso);
    return data.toISOString().split("T")[0]; // yyyy-MM-dd
  };

  const [formData, setFormData] = useState({});
  const [erros, setErros] = useState({});
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    if (aluno) {
      const dados = { ...aluno };
      Object.keys(dados).forEach((k) => {
        if (k.toLowerCase().includes("data") && dados[k]) {
          dados[k] = formatarDataParaInput(dados[k]);
        }
      });
      setFormData(dados);
      console.log("🟩 ModalEditarAluno montado com aluno:", dados);
    }
  }, [aluno]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErros((prev) => ({ ...prev, [name]: "" }));
  };

  const validarCampos = () => {
    const novosErros = {};
    if (!formData.nome_completo) novosErros.nome_completo = "Nome é obrigatório";
    // Email agora é opcional
    if (!formData.telefone_responsavel)
      novosErros.telefone_responsavel = "Telefone do responsável é obrigatório";
    if (!formData.data_nascimento)
      novosErros.data_nascimento = "Data de nascimento é obrigatória";
    if (!formData.classe) novosErros.classe = "Classe é obrigatória";
    return novosErros;
  };

  const handleSalvar = async () => {
    console.log("🟦 Iniciando salvamento de aluno...");
    console.log("formData enviado:", formData);

    const errosValidacao = validarCampos();
    if (Object.keys(errosValidacao).length > 0) {
      console.warn("⚠️ Erros de validação:", errosValidacao);
      setErros(errosValidacao);
      setMensagem("Preencha os campos obrigatórios antes de salvar.");
      return;
    }

    try {
      const res = await fetch(`/api/alunos/${aluno.id}`, {
        method: 'PATCH',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

     if (res.ok) {
  const dadosAtualizados = await res.json();
  setMensagem("✅ Aluno atualizado com sucesso!");
  onAtualizar?.(dadosAtualizados.aluno);
  setTimeout(() => onClose(), 1000);
} else {
        setMensagem("❌ Erro ao atualizar aluno no servidor.");
      }
    } catch (err) {
      console.error("❌ Erro na requisição:", err);
      setMensagem("❌ Erro de comunicação com o servidor.");
    }
  };

  const campos = [
    {
      categoria: "Informações Básicas",
      itens: [
        { label: "Nome Completo", name: "nome_completo" },
        { label: "Gênero", name: "genero", type: "select", options: ["Masculino", "Feminino", "Outro"] },
        { label: "Data de Nascimento", name: "data_nascimento", type: "date" },
        { label: "Classe", name: "classe", type: "select", options: ["1ª", "2ª", "3ª", "4ª", "5ª", "6ª", "7ª", "8ª", "9ª", "10ª", "11ª", "12ª"] },
        { label: "Número do BI", name: "numero_bi" },
      ],
    },
    {
      categoria: "Contato e Saúde",
      itens: [
        { label: "Email", name: "email", type: "email" }, // opcional
        { label: "Telefone do Responsável", name: "telefone_responsavel" },
        { label: "Histórico Médico", name: "historico_medico" },
        { label: "Deficiência", name: "deficiencia" },
        { label: "Doença Crônica", name: "doenca_cronica" },
        { label: "Outras Condições", name: "outras_condicoes" },
      ],
    },
    {
      categoria: "Informações Familiares",
      itens: [
        { label: "Nome do Pai", name: "nome_pai" },
        { label: "Telefone do Pai", name: "telefone_pai" },
        { label: "Nome da Mãe", name: "nome_mae" },
        { label: "Telefone da Mãe", name: "telefone_mae" },
      ],
    },
    {
      categoria: "Matrícula",
      itens: [{ label: "Data da Matrícula", name: "data_matricula", type: "date" }],
    },
  ];

  return (
    <div className="modal">
      <div className="modal-editar-content">
        <h2>Editar Informações do Aluno</h2>

        {mensagem && <div className="mensagem-status">{mensagem}</div>}

        {campos.map((grupo) => (
          <div key={grupo.categoria} className="grupo-categoria">
            <h4>{grupo.categoria}</h4>
            <div className="grupo-campos">
              {grupo.itens.map((field) => (
                <div key={field.name} className="campo-form">
                  <label htmlFor={field.name}>{field.label}</label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                    >
                      <option value="">Selecione</option>
                      {field.options.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      id={field.name}
                      type={field.type || "text"}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                    />
                  )}
                  {erros[field.name] && <span className="erro-campo">{erros[field.name]}</span>}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="botoes-inferiores">
          <button className="btn-modal-salvar" onClick={handleSalvar}>
            Salvar
          </button>
          <button className="btn-modal-cancelar" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalEditarAluno;
